/* CHBP shared add-to-cart helper.
   Adds one or many items via /cart/add.js and updates Dawn's cart drawer /
   notification. Multi-item adds with only a cart notification available fall
   back to the cart page (the notification can only present a single item). */
window.CHBP = window.CHBP || {};
window.CHBP.cartAdd = function (payload, button) {
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var multi = Array.isArray(payload.items) && payload.items.length > 1;

  if (cart && typeof cart.getSectionsToRender === 'function') {
    payload.sections = cart.getSectionsToRender().map(function (s) {
      return s.id;
    });
    payload.sections_url = window.location.pathname;
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }

  if (button) {
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
  }

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    body: JSON.stringify(payload)
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (state) {
      if (state.status) throw new Error(state.description || 'Could not add to cart');
      var isNotification = cart && cart.tagName === 'CART-NOTIFICATION';
      if (!cart || (multi && isNotification)) {
        window.location = window.Shopify.routes.root + 'cart';
        return state;
      }
      cart.renderContents(state);
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      return state;
    })
    .catch(function (error) {
      console.error('[CHBP cart]', error);
      alert(error.message || 'Could not add to cart');
    })
    .finally(function () {
      if (button) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }
    });
};
